import PartList from "@/components/Parts/PartList.vue";
import PartEdit from "@/components/Parts/PartEdit.vue";
import PartFilter from "@/components/Parts/PartFilter.vue";
import PartHeader from "@/components/Parts/PartHeader.vue";

export default [
    {
        path: 'part',
        alias: 'parts',
        name: 'All Parts',
        redirect: "/part/list",
        components: {
            page: PartList,
            header: PartHeader
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "filter",
                name: "Part Filter",
                components: {
                    modal: PartFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Part List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Part New",
                components: {
                    modal: PartEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Part Edit",
                components: {
                    modal: PartEdit,
                }
            }
        ]
    }
];